import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUIStore = defineStore('ui', () => {
  const isSidebarOpen = ref(false);
  const isAdminSectionVisible = ref(false);

  function toggleSidebar() {
    isSidebarOpen.value = !isSidebarOpen.value;
  }

  function closeSidebar() {
    isSidebarOpen.value = false;
  }

  function toggleAdminSection() {
    isAdminSectionVisible.value = !isAdminSectionVisible.value;
  }

  return { 
    isSidebarOpen, 
    isAdminSectionVisible,
    toggleSidebar, 
    closeSidebar,
    toggleAdminSection
  };
});
